import { Spacing } from 'UI'
import { createUseStyles } from 'react-jss'
import BoostCareer from '../BoostCareer'
import EntrepriseOffer from '../EntrepriseOffer'
import Tags from '../Tags'
import Categories from '../Categories'
import ActionButtons from './ActionButtons'
import CourseInfos from './CourseInfos'
import Infos from './Infos'
import style from './style'

const useStyles = createUseStyles(style)

export default ({ scrollToPricing, loading, scrollToReviews, IsFree }) => {
  const { root } = useStyles()

  return (
    <div className={root}>
      {
        IsFree
          ? (
            <>
              <ActionButtons scrollToPricing={scrollToPricing} />
              <CourseInfos loading={loading} margin={Spacing(3, 0, 4, 0)} />
              <Infos margin={Spacing(0, 0, 4, 0)} scrollToReviews={scrollToReviews} />
              <BoostCareer margin={Spacing(0, 0, 4, 0)} />
              <EntrepriseOffer loading={loading} noMargin margin={Spacing(0, 0, 4, 0)} />
              <Categories />
              <Tags />
            </>
            )
          : (
            <>
              <ActionButtons scrollToPricing={scrollToPricing} />
              <Infos margin={Spacing(3, 0, 4, 0)} scrollToReviews={scrollToReviews} />
              <BoostCareer margin={Spacing(0, 0, 4, 0)} />
              <EntrepriseOffer loading={loading} noMargin margin={Spacing(0, 0, 4, 0)} />
              <CourseInfos loading={loading} margin={Spacing(0, 0, 4, 0)} />
              <Categories />
              <Tags />
            </>
            )
      }
    </div>
  )
}
